import PathwayCard from 'components/shared/PathwayCard/PathwayCard'
import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'

import './PathwayCardList.scss'

export const PathwayCardList = ({
  pathways,
  locale,
  translateTitles = true,
  translateDescriptions = true,
  t,
  className = null,
}) => {
  return (
    <div className={`c-pathway-card-list u-clearfix ${className}`}>
      {pathways.map((pathway) => {
        return (
          <PathwayCard
            pathway={pathway}
            locale={locale}
            translateTitle={translateTitles}
            translateDescription={translateDescriptions}
            t={t}
            key={pathway.id}
          />
        )
      })}
    </div>
  )
}

PathwayCardList.propTypes = {
  locale: PropTypes.string.isRequired,
  pathways: PropTypes.array.isRequired,
  translateTitles: PropTypes.bool,
  translateDescriptions: PropTypes.bool,
  t: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default translate('translations')(PathwayCardList)
